export default __webpack_public_path__ + "static/media/card-envelope.b50899d5.jpg";